export default __webpack_public_path__ + "assets/models/a461a9d81ffdf7c3c354a13701022228.glb";